import { render } from "./language-switch.vue?vue&type=template&id=1b5c1511"
import script from "./language-switch.vue?vue&type=script&lang=js"
export * from "./language-switch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__